<template>
    <div class="outer-container">
        <div class="page_mobile_abuoth flex-col">
            <div class="section_4 ">
                <div class="group_13 flex-col">
                    <div class="block_13 flex-row justify-between">
                        <div class="image-text_11 flex-row justify-between">
                            <img
                                    class="label_icon"
                                    referrerpolicy="no-referrer"
                                    :src="introItem.labelIcon"
                            />
                            <span class="text-group_3">{{introItem.title}}</span>
                        </div>
                        <!--<span class="text_18">{{introItem.enTitle}}</span>-->
                    </div>
                    <img
                            class="image_7"
                            referrerpolicy="no-referrer"
                            src="../assets/img/SketchPng058f619c4fb320f70ecaf25f56f7aeef8e86cb75e1a2bd6987e3454070ae04d8.png"
                    />
                    <div class="text-group_19 flex-col justify-between">
                        <span class="text_19">{{introItem.content}}</span>
                        <span class="text_20">{{introItem.production}}</span>
                    </div>
                </div>
            </div>
            <div class="about_img_container">
                <div class="about_img flex-col" :style="bannerStyle"></div>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'IntroComponent',
        props: {
            introItem: {
                type: Object,
                required: true,
                default: () => ({
                    title: '',
                    enTitle: '',
                    content: '',
                    production: '',
                    img: ''
                })
            }
        },
        data() {
            return {
                /*
                introItem:{
                    title:'渠道风控管理',
                    enTitle:'Channel',
                    content:'作为医药领域渠道风控与合规管理服务的先行者之一，康柏汉森深耕行业近二十年，我们提供从常规核查到深度核查的创新风控管理解决方案，覆盖企业内部人员、经销商、药店及医院等多渠道多管理环节，助力客户破解渠道管理中的核心痛点。通过彻查问题并建立监督制约机制，提升销售数据的真实性和准确性，改善营销决策的有效性，优化渠道管理绩效，助力企业实现高效、透明的渠道运营与管理。',
                    production:'核心产品：直连审核、经销商核查、终端核查、票据核查',
                    img:require('@/assets/advisory/advisory_select_type1_01.png'),
                }*/
            };
        },
        computed: {
            bannerStyle() {
                return {
                    backgroundImage: `url(${this.introItem.img})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                };
            }
        },
        methods: {}
    };
</script>
<style scoped lang="css" >
    .outer-container {
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .page_mobile_abuoth {
        position: relative;
        max-width: 1200px;
        height: 100%;
        overflow: hidden;
        margin: 0 auto;
        align-items: center;
        margin-top: 20px;
    }

    .section_4 {
        width: 100%;
        background-color: rgba(255, 255, 255, 1);
        max-width: 1200px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .justify-between {
        display: flex  ;
        justify-content: space-between;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .group_13 {
        width: calc(100% - 40px);
        max-width: 700px;
        margin: 0 auto;
        padding-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .block_13 {
        width: 100%;
        height: 33px;
    }

    .image-text_11 {
        width: 182px;
        height: 33px;
    }

    .label_icon {
        width: 26px;
        height: 25px;
        margin-top: 4px;
    }

    .text-group_3 {
        width: 144px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .text_18 {
        width: 83px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 22px;
        text-align: center;
        white-space: nowrap;
        line-height: 22px;
        margin-top: 6px;
    }

    .image_7 {
        width: 100%;
        max-width: 700px;
        height: 1px;
        margin-top: 19px;
    }

    .text-group_19 {
        width: 100%;
        max-width: 700px;
        margin-top: 14px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_19 {
        width: 100%;
        overflow-wrap: break-word;
        color: rgba(85, 85, 85, 1);
        font-size: 18px;
        text-align: justify;
        line-height: 32px;
    }

    .text_20 {
        max-width: 100%;
        overflow-wrap: break-word;
        color: rgba(0, 120, 126, 1);
        font-size: 18px;
        text-align: left;
        line-height: 28px;
        margin-top: 14px;
    }


    .about_img_container {
        width: calc(100% - 40px);
        max-width: 690px;
        overflow: hidden;
        position: relative;
        margin-top: 10px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .about_img {
        width: 100%;
        height: 230px;
        position: relative;
        display: flex;
        justify-content: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        transition: transform 0.3s ease;
    }
    .about_img:hover {
        transform: scale(1.2);
    }


    /* 超小屏幕样式 */
    @media (max-width: 480px) {
        .about_img {
            height: 30vh; /* 使用视口高度单位，确保高度为25% */
            width: 100%;
        }
        .group_13 {
            padding-left: 10px;
            padding-right: 10px;
            padding-bottom: 0px;
        }
        .text-group_3 {
            font-size: 20px;
        }
        .text_19 {
            font-size: 13px;
            line-height: 23px;
        }
        .text_20 {
            font-size: 13px;
            line-height: 28px;
        }
    }
    @media (max-width: 390px) {
        .about_img {
            height: 30vh; /* 使用视口高度单位，确保高度为25% */
            width: 100%;
        }
        .group_13 {
            padding-left: 10px;
            padding-right: 10px;
        }
        .text-group_3 {
            font-size: 19px;
        }
        .text_19 {
            font-size: 13px;
            line-height: 23px;
        }
        .text_20 {
            font-size: 13px;
            line-height: 28px;
        }
    }

</style>
